export const padZero = (number, cover) => {
    return Array(cover).join(0).concat(number).slice(-cover)
}

export const getFullToday = () => {
    const date = new Date()
    const year = date.getFullYear()
    const month = date.getMonth() + 1
    const day = date.getDate()
    return `${year}-${padZero(month, 2)}-${padZero(day, 2)}`
}

// 1-待开始；2-已完成；3-已逾期
export const getTodoCheckDisabled = (remindDate, isCheck, todoStatus) => {
    const isToday = remindDate === getFullToday()
    // 待开始并不是今天，禁选
    if (todoStatus === 1 && !isToday) {
        return true
    }
    // 已完成都禁选
    if (todoStatus === 2) {
        return true
    }

    // 已选中的禁选
    return isCheck
}
